// Public components
import Popper, { placements } from './Popper';
import Manager from './Manager';
import Reference from './Reference';
export { Popper, placements, Manager, Reference }; // Public types


//////////////////
// WEBPACK FOOTER
// ./~/react-popper/lib/esm/index.js
// module id = 924
// module chunks = 0